import store from "../../redux/store";

export const isGranted = (roles: Array<string>): boolean => {

    if (store.getState().users.currentUser.data.roles) {
        const allRoles = store.getState().users.currentUser.data.roles;

        const hasRole = roles.every(item => allRoles.includes(item));

        return hasRole;
    } else {
        return false
    }

}